export default {
  en: {
    specialOffer: 'Special Offer',
    agentList: 'Agent List',
    refCode: 'Ref Code',
    promotion: 'Promotion',
    agentName: 'Agent Name',
    filterByName: 'Filter By Name',
    download: 'Download',
    preview: 'Preview',
    email: 'Email',
    noData: 'No Data',
    signedDocument: 'Signed Document'
  },
  th: {
    specialOffer: 'ข้อเสนอพิเศษ',
    agentList: 'รายชื่อตัวแทน',
    refCode: 'รายชื่อตัวแทน',
    promotion: 'โปรโมชั่น',
    agentName: 'ชื่อตัวแทน',
    filterByName: 'ค้นหาด้วยชื่อ',
    download: 'ดาวน์โหลด',
    preview: 'ดูตัวอย่าง',
    email: 'อีเมล',
    noData: 'ไม่มีข้อมูล',
    signedDocument: 'เอกสารลงนาม'
  }
}
